/** Demo content for StandardModal's sidebar region. */
export const StandardModalDemoSidebar = () => {
    return <div>Sidebar content</div>;
};
